import React, { useState } from 'react';
import ReactStars from "react-rating-stars-component";
import { connect } from 'react-redux';
import styled from 'styled-components';

import Modal from '../../../Components/UI/Modal/Modal';
import Button from '../../../Components/UI/Forms/Button/Button';
import Heading from '../../../Components/UI/Headings/Heading';
import Message from '../../../Components/UI/Messages/Message';

import * as actions from '../../../Store/Actions';
import { deletOfferArtisanAction, paymentConfirmationAPI, reviewArtisanAPI } from '../../../Store/Actions/actionOffer';

const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 2rem;
  justify-content: space-around;
`;

const DemandWrapper = styled.div`
  margin: 1rem 0rem;
  font-size: 1.3rem;
  font-weight: 700;
  text-align: center;
  color: #2e2e2e;
`;

const MessageWrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  width: 100%;
  padding: 0 3rem;
`;

const Editor = styled.div`
    padding: 12px 24px;
    width:100%;
    textarea{
        width: 100%;
        min-height: 100px;
        resize: none;
        border-radius:8px;
        background-color: #e0e6ee ;
        padding-left:5px;
    }

    input{
        width: 100%;
        height: 35px;
        font-size: 16px;
        margin-bottom: 20px;
    }
   
`;


const ReviewClientModal = ({show, close, demand, error, loading, addReview}) => {

    const [rating, setRating]=useState(0);
    const [editorText, setEditorText]= useState('')

    const ratingChanged = (newRating) => {
        setRating(newRating);
        console.log(newRating);
      };

      const reviewArtisan = (e)=>{
          const review={
              demandId :demand.demand_id,
              reviewText: editorText,
              rating: rating,
              artisanId: demand.contract.artisan_id,
          }
          addReview(review);
      }

    return (
        <Modal opened = {show} close={close}>
            <Heading noMargin size="h1" color="black">
            Votre avis 
            </Heading>
            <Heading bold size="h4" color="black">
            Veuillez revoir ce service. Votre avis nous aidera à fournir les meilleurs services.
            </Heading>

            <Editor>
                <label id='reviewText'>Votre avis</label>
                <textarea
                    style={{fontSize:'16px'}}
                    value={editorText}
                    onChange={(e)=> setEditorText(e.target.value)}
                    placeholder='How was the service...'
                >
                </textarea>

                <label id='scoreLabel'>Quelle note accordez-vous à cet artisan ?</label>
                <ReactStars
                count={5}
                onChange={ratingChanged}
                size={24}
                isHalf={false}
                emptyIcon={<i className="far fa-star"></i>}
                halfIcon={<i className="fa fa-star-half-alt"></i>}
                fullIcon={<i className="fa fa-star"></i>}
                activeColor="#e0e6ee"
            />
            </Editor> 
            <DemandWrapper>{demand.demand}</DemandWrapper>
            
            <ButtonsWrapper>
                
                <Button color="red" contain onClick={close}>
                Annuler
                </Button>
                <div onClick={close}>
                <Button
                contain
                color="white"
                onClick={ async() => 
                    await reviewArtisan(demand)}
                
                disabled={loading}
                loading={loading ? 'Deleting...' : null}
                > 
                Publier l'avis
                </Button>
                </div>
                <MessageWrapper>
                    <Message error show={error}>
                    {error}
                    </Message>
                </MessageWrapper>
            </ButtonsWrapper>
        </Modal>  
    )
}


const mapStateToProps = ({demands}) => ({
    error: demands.deleteDemand.error,
    loading: demands.deleteDemand.loading
})

const mapDispatchToProps = (dispatch)=>( {
     addReview: (demand) => dispatch(reviewArtisanAPI(demand))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
    )(ReviewClientModal);